class ErrorUtil {
    /**
     * Handles an unknown error by converting it to an Error if it's not already.
     * Includes detailed formatting and safe stringification for complex objects.
     * @param error The unknown error caught in a catch block.
     * @returns The error as an instance of Error with detailed information.
     */
    public static handleUnknownError(error: unknown): Error {
        return error instanceof Error
            ? new Error(`${error.message}\nStack Trace: ${error.stack}`)
            : typeof error === "string"
              ? new Error(error)
              : error === null || error === undefined
                ? new Error("An unknown error occurred")
                : new Error(`Unknown error: ${ErrorUtil.safelyStringify(error)}`)
    }

    private static safelyStringify(obj: unknown): string {
        try {
            return JSON.stringify(obj, null, 2)
        } catch {
            return "Unserializable message"
        }
    }
}

export default ErrorUtil
